import sessionStore from "../../store/session";
import type { RequestInterceptor } from "./types.js";

export const setApiTokenInRequest: RequestInterceptor = (request) => {
  request.headers.set("x-access-token", sessionStore.accessToken);
  return request;
};
